module.exports = __webpack_public_path__ + "img/서울대입구 고기집.34a77fe7.png";